<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M66.2016 33.1982C50.3172 33.0516 26.516 35.5637 27.0348 47.016C28.0075 68.4771 119.632 62.3901 94.3081 53.2609C71.3526 44.986 22.6619 55.8181 17.852 71.1978C14.7084 81.2546 13.3185 99.231 22.5012 104.909C32.5044 111.095 88.7877 107.714 88.7877 107.714C88.7877 107.714 109.014 107.588 109.702 95.36"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M96.3691 109.073L96.4255 113.342C96.434 115.366 98.0833 116.999 100.105 116.987L104.311 116.968C106.336 116.959 107.968 115.31 107.957 113.288L107.9 103.421"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M20.4297 105.507L20.4861 113.689C20.4917 114.797 20.9851 115.786 21.7661 116.454C22.4117 117.01 23.2491 117.343 24.1654 117.337L28.3747 117.317C29.2346 117.314 30.0212 117.018 30.6415 116.519C31.4873 115.846 32.0258 114.802 32.023 113.638L31.9666 109.558"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M108.502 94.8129C109.105 88.6216 109.105 82.481 108.468 76.3375C108.045 74.4316 108.045 72.3143 106.139 71.0427C105.079 70.4084 104.022 69.7712 103.388 68.7139C103.176 68.291 102.965 67.6538 102.753 67.2309C101.059 59.1844 98.7301 52.1951 96.4013 44.5715C95.5555 41.6055 93.909 39.4149 91.3518 37.5315C91.2588 37.4639 91.1065 37.368 90.9176 37.2609C89.9872 36.728 88.9807 36.353 87.9347 36.119C86.4207 35.7807 83.6464 35.2281 81.5234 35.1548"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.1675 79.5911C84.7991 79.9717 85.1487 80.6878 85.0669 81.4209C85.0331 81.7113 84.9964 82.0355 84.9598 82.3654C84.957 82.3823 84.9541 82.3992 84.9541 82.4161C84.8498 83.2873 84.7455 84.2008 84.675 84.697C84.6384 84.9789 84.2352 85.4131 83.6206 85.9178C82.9834 86.4478 82.1122 87.0483 81.1903 87.6122C79.3633 88.7428 77.339 89.7352 76.5411 89.7409L64.1696 89.7972C64.1696 89.7972 64.1358 89.7972 64.0822 89.7972L51.7136 89.8536C50.9157 89.8565 48.883 88.8838 47.0419 87.7701C46.1171 87.2119 45.2431 86.6226 44.5947 86.0982C43.9772 85.5992 43.5684 85.1678 43.5289 84.8887C43.4528 84.3925 43.34 83.4846 43.2301 82.6135L43.2216 82.5571C43.1822 82.2272 43.1399 81.903 43.106 81.6126C43.0158 80.8824 43.3598 80.1662 43.9857 79.7772C43.9913 79.7743 43.997 79.7687 44.0026 79.7659C44.0336 79.7462 44.0646 79.7264 44.0956 79.7067C44.1407 79.6785 44.1887 79.6475 44.2366 79.6221C44.3156 79.5685 44.3945 79.5206 44.4791 79.4755C45.2516 79.0103 46.12 78.5366 46.5429 78.4549C47.3859 78.2913 63.1462 78.3675 64.071 78.3731C64.9929 78.359 80.7504 78.1363 81.5963 78.2913C82.022 78.3703 82.8904 78.8355 83.6713 79.2922C83.7559 79.3373 83.8348 79.3853 83.9138 79.436C83.9617 79.4614 84.0125 79.4896 84.0576 79.5178C84.0858 79.5375 84.1196 79.5544 84.1478 79.577C84.1534 79.5798 84.1591 79.5854 84.1647 79.5883L84.1675 79.5911Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M100.303 72.7146C100.303 72.7146 96.9986 74.9645 93.432 76.7435C89.8627 78.5225 88.2105 78.7706 87.9483 79.6926C87.6861 80.6145 90.5816 82.3174 91.6502 82.3654C92.7187 82.4133 101.552 82.0157 103.198 80.4594C104.845 78.9031 105.612 74.2117 105.127 73.3602"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M27.2742 72.4778C27.2742 72.4778 31.1086 75.269 34.692 77.0113C38.2755 78.7565 39.9333 78.9906 40.2039 79.9097C40.4746 80.8288 37.5932 82.5571 36.5246 82.6163C35.4561 82.6755 26.6201 82.3569 24.9595 80.8175C24.7114 80.5863 24.4859 80.2903 24.2716 79.9435C23.0818 77.9671 22.5602 74.4654 22.9662 73.7352"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M26.7543 93.0142L38.0403 96.8232C38.9115 97.1164 39.2695 98.1568 38.762 98.9236L37.9952 100.088C37.7132 100.517 37.217 100.756 36.7067 100.714L25.9705 99.8117C25.5814 99.7779 25.2233 99.5862 24.9837 99.2761L23.6445 97.5619C23.2752 97.0882 23.247 96.4285 23.5796 95.9266L25.1331 93.5725C25.4827 93.0424 26.1481 92.814 26.7515 93.017L26.7543 93.0142Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M23.9737 67.6735C23.9653 68.7956 16.4206 67.5495 15.8849 67.2845C15.6791 67.183 15.3577 66.7262 15.0983 66.1426C14.9686 65.8466 14.8558 65.5195 14.7797 65.1868C14.6162 64.4594 14.6444 63.7179 15.1209 63.2866C16.2373 62.266 22.1016 60.9324 23.1194 61.3778C24.1344 61.8289 23.9737 67.6735 23.9737 67.6735Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M23.5868 65.1644L26.6289 65.0375L25.6562 68.1162L22.5605 68.1303L23.5868 65.1644Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M80.8689 94.8017C80.5447 94.1081 78.0298 92.6251 77.0684 92.6308C76.1521 92.6336 65.1931 92.6843 64.181 92.69C64.181 92.69 64.1472 92.69 64.0992 92.69C63.0842 92.6956 52.1281 92.7464 51.2118 92.7492C50.2504 92.7548 47.7496 94.2604 47.431 94.9539C47.1153 95.6503 49.3172 98.574 50.4957 99.4227C51.6347 100.243 63.3972 100.018 64.1753 100.001C64.9563 100.009 76.7188 100.127 77.8494 99.2958C79.0194 98.4359 81.196 95.4896 80.8717 94.7989L80.8689 94.8017Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M101.524 92.6674L90.2716 96.5779C89.4033 96.8796 89.0565 97.9228 89.5696 98.684L90.3478 99.8399C90.6353 100.266 91.1315 100.502 91.6418 100.455L102.37 99.4509C102.759 99.4142 103.114 99.2169 103.354 98.9067L104.676 97.1813C105.042 96.702 105.062 96.0451 104.727 95.546L103.151 93.2059C102.795 92.6787 102.127 92.456 101.527 92.6646L101.524 92.6674Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M104.071 67.3042C104.088 68.4263 111.624 67.1096 112.157 66.8418C112.363 66.7375 112.679 66.2779 112.932 65.6915C113.059 65.3926 113.169 65.0656 113.243 64.7329C113.401 64.0055 113.364 63.2612 112.885 62.8355C111.76 61.8261 105.881 60.5461 104.869 61.0029C103.86 61.4624 104.071 67.307 104.071 67.307V67.3042Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M104.431 64.7922L101.389 64.6935L102.39 67.7638L105.485 67.7497L104.431 64.7922Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.4629 39.4911L83.0453 39.8999C88.092 40.3425 90.4405 42.7165 91.6247 46.8581L95.2786 59.6299C95.6282 60.8479 95.5013 62.0772 95.0361 63.1034C94.2044 64.9501 91.7121 65.7339 89.8428 65.7875"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M80.5293 96.107L80.6562 95.8815C81.8093 93.8233 83.89 92.4475 86.2385 92.2078C88.8831 91.94 91.773 91.5058 94.8461 90.8291C100.462 89.5914 104.861 88.1592 108.655 86.4901"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.7316 96.107L47.6048 95.8815C46.4516 93.8233 44.3709 92.4475 42.0224 92.2078C39.3778 91.94 36.4879 91.5058 33.4148 90.8291C27.7986 89.5914 23.4004 88.1592 19.6055 86.4901"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M87.2962 9.37434C84.2372 9.06985 81.5109 11.3028 81.2036 14.3618C80.8991 17.4209 83.132 20.1472 86.1911 20.4545C89.2501 20.759 91.9764 18.5261 92.2837 15.467C92.5882 12.408 90.3553 9.68166 87.2962 9.37434Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.3977 31.9323L75.0737 38.008C75.0088 38.1236 74.913 38.2167 74.7946 38.2759L74.4309 38.4563C74.2279 38.5578 74.0954 38.7552 74.0756 38.9807L74.0108 39.7476C73.9995 39.8632 73.96 39.9731 73.8924 40.069L72.8492 41.5323C72.7731 41.6394 72.6631 41.724 72.5362 41.7691L72.3586 41.8339C72.0654 41.9411 71.8878 42.2315 71.9329 42.5416L71.9442 42.6177C71.9696 42.7869 71.9273 42.9589 71.8286 43.0942L70.1313 45.4258C69.934 45.6965 69.5562 45.7754 69.2489 45.6091L68.8372 45.3864C68.5299 45.22 68.3918 44.8619 68.5074 44.549L69.5252 41.8508C69.5844 41.693 69.7056 41.5661 69.8607 41.4928L69.9311 41.459C70.2159 41.3264 70.3625 41.0219 70.2892 40.7146L70.2469 40.5314C70.2159 40.3989 70.2244 40.2635 70.2723 40.1395L70.9236 38.4648C70.9659 38.3576 71.0363 38.2618 71.1266 38.1913L71.7327 37.7176C71.9103 37.5795 72.0034 37.3567 71.978 37.1312L71.9301 36.728C71.916 36.5955 71.9414 36.4658 72.0006 36.3474L75.257 30.235"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.4914 20.5786L80.8733 18.0835C79.4016 17.2884 77.4365 17.8326 76.1818 19.4283C75.0062 20.9226 73.8135 23.1358 73.2074 24.9374C72.5617 26.8602 73.182 28.8028 74.6565 29.5978L79.2747 32.093C80.7464 32.8881 82.7115 32.3439 83.9661 30.7481C85.1418 29.2539 86.3344 27.0407 86.9406 25.2391C87.5862 23.3163 86.966 21.3737 85.4914 20.5786Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.2675 25.6C84.682 24.3623 84.2845 23.1133 83.3343 22.6002L80.3599 20.996C79.4126 20.4829 78.1467 20.8353 77.3403 21.8615C76.5847 22.8229 75.9926 23.9225 75.6008 25.0813C75.1863 26.319 75.5838 27.568 76.534 28.0811L79.5084 29.6853C80.4557 30.1984 81.7216 29.846 82.528 28.8198C83.2836 27.8584 83.8756 26.7588 84.2675 25.6Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M104.303 26.0144C102.794 23.7166 99.0191 18.8954 97.787 17.7677C96.2899 16.4003 94.2628 16.1803 92.9377 17.2066L88.7875 20.4207C87.4624 21.447 87.1664 23.4628 88.1165 25.2559C89.0075 26.9363 93.7158 33.0149 95.1171 34.3005C96.6142 35.6679 98.6413 35.8878 99.9664 34.8616L104.117 31.6475C104.852 31.078 105.27 30.204 105.335 29.2313C105.36 28.8422 105.329 28.4362 105.239 28.0302"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M101.744 31.6644C101.995 31.9858 101.936 32.451 101.612 32.6991C101.291 32.95 100.825 32.8908 100.577 32.5666C100.326 32.2452 100.386 31.78 100.71 31.5319C101.034 31.2838 101.496 31.3402 101.744 31.6644Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.122 20.4715C96.1578 19.589 94.8552 19.4509 94.0009 20.1106L91.3282 22.1801C90.4767 22.8398 90.285 24.1367 90.8968 25.2927C91.4691 26.3753 94.875 30.7707 95.7772 31.5968C96.7414 32.4793 98.0439 32.6174 98.8982 31.9577L101.571 29.8882C102.422 29.2285 102.614 27.9316 102.002 26.7756C101.43 25.693 98.0242 21.2976 97.122 20.4715Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.0527 45.4286L76.0927 32.3861"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.4258 23.2373L83.5222 27.1055"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.0801 26.8151L98.3307 22.0165"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M94.7402 30.0292L100.968 25.304"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M36.4258 118.651C43.2741 117.416 53.2913 116.063 65.4993 115.961C76.0212 115.874 84.7895 116.745 91.1359 117.653"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M66.757 39.2487C59.9454 39.1613 53.8132 39.6772 48.5156 40.4356"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17.8047 44.5969C18.3855 42.6938 19.5471 39.7222 21.9323 36.6941C24.5007 33.4321 27.3511 31.5403 29.1358 30.5394"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M15.7324 40.6526C16.1722 39.2119 17.0519 36.9677 18.8535 34.6756C20.796 32.2086 22.95 30.7763 24.3033 30.0208"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
